<template>
    <v-container fluid class="page-container">
        <page-header title="Promo pages" :subtitle="totalLabel">
            <v-btn color="primary" depressed @click="createItem">
                <v-icon left>mdi-plus</v-icon>New promo page
            </v-btn>
        </page-header>

        <filter-panel :fields="filterFields" :value="listState" :loading="loading" @apply="applyFilters" />

        <v-card outlined>
            <v-data-table
                :headers="visibleHeaders"
                v-bind="tableBindings"
                class="list-table clickable-rows"
                no-data-text="No promo pages match this search"
                @update:options="onTableOptions"
                @click:row="openItem($event)"
            >
                <template v-slot:[`item.title`]="{ item }">
                    <span class="font-weight-medium">{{ item.title }}</span>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <div class="d-flex justify-end">
                        <v-btn icon small color="primary" title="Edit" @click.stop="openItem(item, 'edit')">
                            <v-icon small>mdi-pencil-outline</v-icon>
                        </v-btn>
                        <delete-button title="Delete this promo page?" @delete-entry="deleteItem(item, deletePromo, 'Promo page')" />
                    </div>
                </template>
            </v-data-table>
            <table-footer v-model="page" :page-count="pageCount" :total="total" :items-per-page="itemsPerPage" />
        </v-card>
    </v-container>
</template>

<script>
    import promoService from '@/services/promo-service'
    import paginatedList from '@/mixins/paginated-list'
    import PageHeader from '@/components/PageHeader'
    import FilterPanel from '@/components/FilterPanel'
    import TableFooter from '@/components/TableFooter'
    import DeleteButton from '@/components/DeleteButton'

    export default {
        name: 'PromoRoute',
        components: { PageHeader, FilterPanel, TableFooter, DeleteButton },
        mixins: [paginatedList],
        data() {
            return {
                filterFields: [
                    { key: 'search', label: 'Search', placeholder: 'Title' }
                ],
                headers: [
                    { text: 'Id', value: 'id', width: 80 },
                    { text: 'Title', value: 'title' },
                    { text: '', value: 'actions', align: 'end', sortable: false, width: 96 }
                ]
            }
        },
        methods: {
            fetchPage: options => promoService.getPromosPage(options),
            deletePromo: id => promoService.deletePromoById(id)
        }
    }
</script>
